import { LogOut, Bell, UserCircle2, BarChart3, Rocket } from "lucide-react";
import { motion } from "framer-motion";
import { useAuth } from "../Auth/AuthContext";
import StatusPing from "../Components/Animations/StatusPing";
import ThemeToggle from "../Components/Animations/ThemeToggle";
import ClockWeatherWidget from "../Components/Animations/ClockWeatherWidget";

export default function Topbar() {
  const { user, logout } = useAuth();

  return (
    <motion.header
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="bg-white shadow-md border-b border-gray-200 px-6 py-4 flex items-center justify-between relative z-10"
    >
      <motion.h1
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-xl md:text-2xl lg:text-3xl font-extrabold flex items-center gap-2 text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 animate-gradient-x drop-shadow-sm"
      >
        <Rocket className="w-6 h-6 text-pink-500 animate-bounce-slow" />
        AdblastX Monetization Hub
      </motion.h1>

     
      

      {/* Right: User Section */}
      <div className="flex items-center gap-4">

        <div className="hidden sm:block">
        <ClockWeatherWidget />
      </div>

        {/* <ThemeToggle /> */}
        {/* ✅ Status Ping */}
        {/* <div className="hidden sm:flex">
          <StatusPing label="API is building" color="yellow" />
        </div> */}

        {/* Notifications */}
        <button className="relative group">
          <Bell className="w-5 h-5 text-gray-500 group-hover:text-indigo-600 transition" />
          <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full animate-ping" />
        </button>

        {/* User Info */}
        <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full shadow-inner hover:shadow-lg transition">
          <UserCircle2 className="w-6 h-6 text-gray-600" />
          <span className="text-sm text-gray-700 font-medium">
            {user?.email?.split("@")[0] || "Admin"}
          </span>
        </div>

        {/* Logout Button */}
        <button
          onClick={logout}
          className="flex items-center gap-1 text-sm text-red-500 hover:text-red-600 transition font-medium"
        >
          <LogOut className="w-4 h-4" />
          Logout
        </button>
      </div>
    </motion.header>
  );
}
